import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import ContactForm from './ContactForm';

const MainContainerAdhesion2 = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const contactData = [
    {
      icon: <FaMapMarkerAlt />,
      title: 'Notre Adresse',
      details: [
        '03, Imm ITC, Avenue Bas-Congo',
        'Gare centrale, Commune de la Gombe',
        'Kinshasa, RDC'
      ]
    },
    {
      icon: <FaPhone />,
      title: 'Téléphones',
      details: [
        '+243 822 764 820',
        '+243 820 676 299',
    
      ],
      links: [
        { number: '+243822764820', type: 'phone' },
        { number: '+243835593568', type: 'whatsapp' },
        { number: '+243999999999', type: 'phone' }
      ]
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      details: [
        'contact@kmj-lawfirm.com',
        'infos@kmj-lawfirm.com',
        'urgence@kmj-lawfirm.com'
      ],
      links: [
        { email: 'contact@kmj-lawfirm.com' },
        { email: 'infos@kmj-lawfirm.com' },
        { email: 'urgence@kmj-lawfirm.com' }
      ]
    }
  ];

  const contactVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] }
    }
  };

  return (
    <section className="contact-info-section">
      {/* Texture luxueuse */}
      <div className="noise-overlay" />

      {/* Background Effects (Lumières subtiles) */}
      <div className="background-effects">
        <div className="glow-spot spot-1" />
        <div className="glow-spot spot-2" />
      </div>

      {/* Section Header */}
      <motion.div 
        className="section-header"
        initial={{ opacity: 0, y: -30 }}
        animate={isLoaded ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
      >
        <span className="section-badge">Assistance Juridique</span>
        <h1 className="section-title">Contactez-nous</h1>
        <p className="section-subtitle">
          Notre équipe se tient à votre entière disposition pour vous conseiller, vous assister et défendre vos intérêts avec rigueur et discrétion.
        </p>
      </motion.div>

      {/* Contact Grid */}
      <div className="contact-grid">
        {contactData.map((item, index) => (
          <motion.div
            key={index}
            className="contact-card"
            variants={contactVariants}
            initial="hidden"
            animate={isLoaded ? "visible" : "hidden"}
            transition={{ delay: index * 0.15 }}
            whileHover={{ y: -5, borderColor: '#C1A68D' }}
          >
            {/* Icon Container */}
            <div className="icon-container">
              <div className="icon-wrapper">
                <div className="icon-content">
                  {item.icon}
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="card-content">
              <h3 className="card-title">{item.title}</h3>
              
              <div className="details-list">
                {item.details.map((detail, idx) => {
                  if (item.links && item.links[idx]) {
                    const link = item.links[idx];
                    
                    if (link.email) {
                      return (
                        <motion.a
                          key={idx}
                          href={`mailto:${link.email}`}
                          className="detail-item link-item"
                          whileHover={{ x: 5, color: '#F5F0E6' }}
                          transition={{ duration: 0.2 }}
                        >
                          <span className="detail-bullet" />
                          <span className="detail-text">{detail}</span>
                        </motion.a>
                      );
                    }
                    
                    if (link.number) {
                      const isWhatsapp = link.type === 'whatsapp';
                      return (
                        <motion.div
                          key={idx}
                          className="detail-item phone-item"
                          whileHover={{ x: 5 }}
                          transition={{ duration: 0.2 }}
                        >
                          <span className="detail-bullet" />
                          <a 
                            href={isWhatsapp ? `https://wa.me/${link.number}` : `tel:${link.number}`}
                            className="phone-link"
                          >
                            {detail}
                            {isWhatsapp && <FaWhatsapp className="whatsapp-icon" />}
                          </a>
                        </motion.div>
                      );
                    }
                  }
                  
                  return (
                    <motion.div key={idx} className="detail-item">
                      <span className="detail-bullet" />
                      <span className="detail-text">{detail}</span>
                    </motion.div>
                  );
                })}
              </div>
            </div>

            {/* Footer Badge (uniquement pour le téléphone/email si besoin, ou général) */}
            {index === 1 && (
              <div className="card-footer">
                <span className="availability-badge">
                  <span className="badge-dot" />
                  Disponible 24h/24
                </span>
              </div>
            )}
          </motion.div>
        ))}
      </div>

      {/* Formulaire de Contact */}
      <div className="form-container-wrapper">
        <ContactForm />
      </div>

      <style jsx>{`
        .contact-info-section {
          position: relative;
          background: #0A0A0A;
          color: #F5F0E6;
          padding: 6rem 1.5rem;
          overflow: hidden;
        }

        .noise-overlay {
          position: absolute;
          inset: 0;
          background-image: url('https://www.transparenttextures.com/patterns/stardust.png');
          opacity: 0.15;
          mix-blend-mode: overlay;
          pointer-events: none;
          z-index: 1;
        }

        /* Background Effects */
        .background-effects {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 0;
        }

        .glow-spot {
          position: absolute;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(193, 166, 141, 0.05) 0%, transparent 70%);
        }

        .spot-1 { width: 600px; height: 600px; top: -10%; left: -10%; }
        .spot-2 { width: 500px; height: 500px; bottom: 20%; right: -5%; }

        /* Section Header */
        .section-header {
          text-align: center;
          margin-bottom: 4rem;
          position: relative;
          z-index: 2;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .section-badge {
          display: inline-block;
          border: 1px solid #C1A68D;
          color: #C1A68D;
          padding: 0.5rem 1.2rem;
          border-radius: 2px;
          font-size: 0.85rem;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 1.5rem;
          background: rgba(193, 166, 141, 0.05);
        }

        .section-title {
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: #F5F0E6;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .section-subtitle {
          font-size: 1.1rem;
          color: #D4C5B0;
          line-height: 1.6;
          font-weight: 300;
        }

        /* Contact Grid */
        .contact-grid {
          max-width: 1200px;
          margin: 0 auto 5rem;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 2rem;
          position: relative;
          z-index: 2;
        }

        /* Contact Card */
        .contact-card {
          background: rgba(26, 26, 26, 0.6);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(193, 166, 141, 0.15);
          border-radius: 4px;
          padding: 3rem 2.5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: all 0.3s ease;
          position: relative;
        }

        /* Icon Container */
        .icon-container {
          margin-bottom: 2rem;
        }

        .icon-wrapper {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(193, 166, 141, 0.3);
          background: rgba(193, 166, 141, 0.05);
          transition: all 0.3s ease;
        }

        .contact-card:hover .icon-wrapper {
          background: rgba(193, 166, 141, 0.1);
          border-color: #C1A68D;
        }

        .icon-content {
          color: #C1A68D;
          font-size: 1.8rem;
          display: flex;
        }

        /* Card Content */
        .card-content {
          flex: 1;
          width: 100%;
        }

        .card-title {
          font-size: 1.3rem;
          font-weight: 600;
          text-align: center;
          margin-bottom: 2rem;
          color: #F5F0E6;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        /* Details List */
        .details-list {
          display: flex;
          flex-direction: column;
          gap: 1.2rem;
        }

        .detail-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid rgba(193, 166, 141, 0.1);
        }

        .detail-item:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .detail-bullet {
          flex-shrink: 0;
          width: 6px;
          height: 6px;
          background: #C1A68D;
          border-radius: 1px;
          margin-top: 0.4rem;
        }

        .detail-text {
          flex: 1;
          font-size: 0.95rem;
          color: #D4C5B0;
          line-height: 1.5;
          font-weight: 300;
          transition: color 0.3s ease;
        }

        /* Link Items */
        .link-item, .phone-link {
          text-decoration: none;
          color: #D4C5B0;
          cursor: pointer;
          font-weight: 300;
        }

        .phone-link {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          transition: color 0.3s ease;
        }

        .link-item:hover .detail-text, .phone-link:hover {
          color: #C1A68D;
        }

        .whatsapp-icon {
          color: #C1A68D; /* Uniformisé en beige/doré pour rester chic */
          font-size: 1.2rem;
        }

        /* Card Footer */
        .card-footer {
          margin-top: 2.5rem;
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .availability-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          background: transparent;
          border: 1px solid rgba(193, 166, 141, 0.3);
          padding: 0.5rem 1.2rem;
          border-radius: 2px;
          font-size: 0.85rem;
          color: #C1A68D;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .badge-dot {
          width: 6px;
          height: 6px;
          background: #C1A68D;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(1.2); }
        }

        /* Form Wrapper */
        .form-container-wrapper {
          position: relative;
          z-index: 2;
          max-width: 1000px;
          margin: 0 auto;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .contact-info-section { padding: 4rem 1rem; }
          .section-title { font-size: 2.2rem; }
          .contact-card { padding: 2.5rem 1.5rem; }
        }
      `}</style>
    </section>
  );
};

export default MainContainerAdhesion2;